import { GET } from "../../API/get";
import { PUT } from "../../API/put";

export const loadData = async (page_number, serach_text, filter_option, dispatch) => {
    dispatch({ type: "IS_LOADING" });

    let url = getUrl(filter_option, serach_text, page_number);
    let response = await GET(url);

    if (response.status === "Success") {
        dispatch({
            type: "IS_LOADED",
            total_ftms: response.total_ftms,
            total_pages: response.total_pages,
            // page_number: page_number,
            ftms: response.list,
            ftm_stages: response.ftm_stages,
        });
    }
}

export const fetchFtms = async (page_number, serach_text, filter_option, sort_key, sort_direction) => {
    const url = getUrl(filter_option, serach_text, page_number, sort_key, sort_direction);
    const response = await GET(url);

    return response.status === "Success" ? response : null;
}

export const ftmReview = async (ftm_id) => {
    const response = await PUT(`ftm/review`, {
        ftm_id: ftm_id
    });

    return response.status === "Success" ? response : null;
}

export const getStatusText = (ftm_is_new, ftm_is_verify) => {
    if (ftm_is_new == 1) {
        return "NEW TRADESPERSON";
    } else {
        if (ftm_is_verify == 2) {
            return "WAITING FOR APPROVAL";
        } else {
            return "BLOCK";
        }
    }
}

export const getAddress = (ftm) => {
    return (ftm?.ftm_street_address !== "" || ftm?.ftm_street_address !== null ? ftm?.ftm_street_address : "") + " " + (ftm?.ftm_place !== "" || ftm?.ftm_place !== null ? ftm?.ftm_place : "") + " " + (ftm?.ftm_postcode !== "" || ftm?.ftm_postcode !== null ? ftm?.ftm_postcode : "")
}

/**
 * Generates the URL for fetching pending applications based on the provided filter options and search text.
 *
 * @param {string} filter_option - The filter option to apply, can be 'Rejected', 'Verified', or a specific ftm_stage_id.
 * @param {string} serach_text - The search text to filter the applications.
 * @param {number} page_number - The page number to fetch.
 * @returns {string} The generated URL for fetching pending applications.
 */
const getUrl = (filter_option, serach_text, page_number, sort_key, sort_direction) => {
    let url = `pending/applications/${page_number}?search=${serach_text.trim()}&sort_key=${sort_key}&sort_direction=${sort_direction}`;
    // switch (filter_option) {
    //     case 'Rejected':
    //         return url + "&ftm_is_verify=-1";
    //     case 'Verified':
    //         return url + "&ftm_is_verify=1";
    //     default:
    //         return url + `&ftm_stage_id=${filter_option}`;
    // }
    return url + `&ftm_stage_id=${filter_option}`;
}

/**
 * Retrieves the FTM stage information for the given FTM stage ID from the application context.
 *
 * @param {number} ftm_stage_id - The ID of the FTM stage to retrieve information for.
 * @param {object} context - The application context, which should contain the FTM stage information.
 * @returns {object|string} The FTM stage information object if found, or an empty string if not found.
 */
export const getFtmStageInfo = (ftm_stage_id, state) => {
    const ftmStageInfo = state.ftm_stages.find(el => el.ftm_stage_id === ftm_stage_id);
    return ftmStageInfo ? ftmStageInfo : "";
}